import graphql, { getData } from 'api/graphql'

export const CREDIT_CARD_FIELDS = `
id
brand
expiryMonth
expiryYear
last4
`

const BILLING_USAGE_FIELDS = `
inbox {
  channels
  integrations
  users
  cannedReplies
  teams
  satisfactionsRatings
  rules
  customProfile
  premiumIntegrations
}
kb {
  kbs
  articles
  branding
  customScripts
  private
}
`

export const BILLING_PLANS_FIELDS = `
  plans {
    name
    product
    planId
    monthlyPrice
    annualPrice
    active
    minimumQuantity
    features
    pricingModel
    version
  }
`

export const basicFields = `
  provider
  createdAt
  state
  cc_last4
  has_legacy_kb
  billing_cycle
  cancels_at
  kb {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
    pricingModel
  }
  inbox {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
    pricingModel
  }
  usage {
    ${BILLING_USAGE_FIELDS}
  }
  hasLastBillingFailed
  isPaid
  pendingSubscription {
    approvalUrl
    inboxPlan
    kbPlan
    billingCycle
    state
  }
  externalAccountId
  externalSubscriptionId
`

export const EXTENDED_BILLING_FIELDS = `
  state
  cc_last4
  has_legacy_kb
  billing_cycle
  cancels_at
  kb {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
    pricingModel
  }
  inbox {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
    pricingModel
  }
  account {
    upcomingInvoice {
      id
      total
      nextPaymentAttempt
      amountDue
      currency
      lines {
        amount
        proration
      }
    }
    creditBalance
  }
  usage {
    ${BILLING_USAGE_FIELDS}
  }
  pendingSubscription {
    approvalUrl
    inboxPlan
    kbPlan
    billingCycle
    state
  }
  hasLastBillingFailed
  externalAccountId
  externalSubscriptionId
  startTrialDurationDays
`

const BILLING_DATA_QUERY = `
  query BillingDataQuery {
    billing {
      ${EXTENDED_BILLING_FIELDS}
    }
    creditCards {
      ${CREDIT_CARD_FIELDS}
    }
  }
`

export const INVOICES_DATA_QUERY = `
query InvoicesDataQuery {
  invoices {
    id
    paid
    periodStart
    periodEnd
    number
    hostedInvoiceUrl
    invoicePdf
    total
    date
    currency
    status
    lines {
      period {
        start
        end
      }
      plan {
        id
      }
    }
  }
}
`

export const BILLING_INFORMATION_FIELDS = `
name
phone
city
country
line1
line2
postalCode
state
vatId
`

const BILLING_INFORMATION_DATA_QUERY = `
query BillingInformationDataQuery {
  billingInformation {
    ${BILLING_INFORMATION_FIELDS}
  }
}
`

export const fetchBillingData = token => {
  return graphql(token, BILLING_DATA_QUERY).then(getData)
}

export const fetchBillingInformation = token => {
  return graphql(token, BILLING_INFORMATION_DATA_QUERY).then(getData)
}

export const billingQuery = () => `
  query BillingQuery {
    billing {
      ${basicFields}
    }
    creditCards {
      ${CREDIT_CARD_FIELDS}
    }
  }
`
